import React from 'react';
import { Dropdown, Nav, Navbar } from 'react-bootstrap';
import styled from '@emotion/styled';
import { withRouter, Link } from 'react-router-dom';

import {

  MdExitToApp, MdLocalMall,
  MdSettings, MdUpgrade,

} from 'react-icons/md';


import NavigationBreadcrumbs from '../breadcrumbs/Breadcrumbs';


import { TfiPlus } from 'react-icons/tfi';
import ContactUsModal from '../modals/ContactUsModal';
import { AuthContext } from '../../../context/AuthContext';
import LocalMallIcon from 'mdi-react/LocalMallIcon';


const SubmitFeatureRequestButton = styled.button`
  background-color: #0071e1;
  color: white;
  border: 1px solid #0071e1;
  padding: 8px 16px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #005cbf;
    border-color: #005cbf;
  }
`;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.go_to_login = this.go_to_login.bind(this);
    this.go_to_project = this.go_to_project.bind(this);
    this.signout = this.signout.bind(this);

  }


  // Other methods...

  handleModalShow = () => {
    this.setState({ showModal: true });
  };

  handleModalClose = () => {
    this.setState({ showModal: false });
  };


  state = {
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false,
    showModal: false,
  };

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  go_to_login() {
    this.props.history.push('/login');
  }

  go_to_project() {
    this.props.history.push('/projects');
  }

  shouldComponentUpdate(nextProps, nextState) {
    const [{ user_logged_in }] = this.context;
    if (nextState.isOpenUserCardPopover != this.state.isOpenUserCardPopover) {
      return true;
    }

    if (user_logged_in != this.state.user_logged_in) {

      this.state.user_logged_in = user_logged_in;

      return true;
    }
    return false;
  }

  signout() {



    this.props.history.push('/');
  }


  render() {
    const contactOptions = [
      { label: 'Submit Feature Request', value: 'feature' },
      { label: 'Report a Bug', value: 'bug' },
      { label: 'Other', value: 'other' },
    ];
    return (
      <AuthContext.Consumer>
        {({ logout, isAuthenticated }) => (
          <Navbar expand='lg' style={{ minHeight: '65px', backgroundColor: 'white' }}>
            <Navbar.Brand style={{ paddingLeft: '50px' }}>
              <NavigationBreadcrumbs />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls='basic-navbar-nav' />

            <Navbar.Collapse id='basic-navbar-nav'>

              <Nav className='ml-auto'>

                {isAuthenticated &&
                  <Dropdown alignRight>
                    <SubmitFeatureRequestButton onClick={this.handleModalShow}>
                      <TfiPlus className='mr-2' />Submit Feature Request
                    </SubmitFeatureRequestButton>

                    {/* Modal Component */}
                    <ContactUsModal
                      show={this.state.showModal}
                      handleClose={this.handleModalClose}
                      options={contactOptions}
                      defaultReason='feature' // or set to any default value you prefer
                      userLoggedIn={true}
                    />
                    <Dropdown.Toggle variant='transparent' id='dropdown-basic'
                                     style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}>
                      <MdSettings style={{ color: '#30363C', cursor: 'pointer' }} size={24} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ padding: 0 }}>
                      <Dropdown.Header style={{ backgroundColor: 'rgb(250,250,250)', margin: 0 }}>Account
                        Settings</Dropdown.Header>

                      <Dropdown.Divider style={{ margin: 0 }} />
                        <Dropdown.Item  href={'/settings/edit-plan'} style={{ fontSize: '14px' }}>
                           <MdLocalMall   className='mr-2'  />Edit plan
                      </Dropdown.Item>
                      <Dropdown.Item onClick={()=>logout(this.signout)} style={{ fontSize: '14px' }}>
                        <MdExitToApp className='mr-2' />Sign out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                }
              </Nav>
            </Navbar.Collapse>
          </Navbar>)}
      </AuthContext.Consumer>
    );
  }
}

const WrappedClass = withRouter(Header);
export default WrappedClass;


